import { CommonGet, CommonPost } from '../../helpers/HttpClient';
import tokenDecoder from '../../utils/tokenDecoder';

export default {
  getAllGroups,
  getFactoryByGroupID,
  getRoutesForDropDown,
  GetAdvancePaymentDetailsForView,
  GetAdvancePaymentStatusHistory,
  GetAdvancePaymentVoucherDetails,
  DeleteAdvancePayment
};

async function getAllGroups() {
  let response = await CommonGet('/api/Group/GetAllGroups');
  let groupArray = [];
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"];
    }
  }
  return groupArray;
};

async function getFactoryByGroupID(groupID) {
  let response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  let factoryArray = [];
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
};

async function getRoutesForDropDown(factoryID) {
  var routeArray = [];
  const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + factoryID)
  for (let item of Object.entries(response.data)) {
    routeArray[item[1]["routeID"]] = item[1]["routeName"]
  }
  return routeArray;
}

async function GetAdvancePaymentDetailsForView(advancePaymentDetailsView) {
  let response = await CommonPost('/api/AdvancePaymentMg/GetAdvancePaymentDetailsForView', null, advancePaymentDetailsView);
  return response;
}

async function GetAdvancePaymentStatusHistory(advancePaymentRequestID) {
  let response = await CommonGet('/api/AdvancePaymentMg/GetAdvancePaymentStatusHistory', 'advancePaymentRequestID=' + advancePaymentRequestID);
  return response;
}

async function GetAdvancePaymentVoucherDetails(advancePaymentRequestID, issuingDate) {
  let response = await CommonGet('/api/AdvancePaymentMg/GetAdvancePaymentVoucherDetails', 'advancePaymentRequestID=' + advancePaymentRequestID + '&issuingDate=' + issuingDate);
  return response;
}


async function DeleteAdvancePayment(deleteModel) {
  deleteModel.modifiedBy = tokenDecoder.getUserIDFromToken();
  const response = await CommonPost('/api/AdvancePaymentMg/DeleteAdvancePayment',
    null,
    deleteModel
  );
  return response;
}